var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"auth",attrs:{"height":_vm.$vuetify.breakpoint.xs ? '100%' : '',"width":_vm.$vuetify.breakpoint.xs ? '100vw' : '90%',"max-width":_vm.$route.path == '/auth/signup' ? '1000px' : '500px'}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }